export default {
  "FoodC_419_gQWM_QlQW": "Sólo en algunas tiendas",
  "FoodC_419_Gvte_qlpC": "Todas las horas",
  "FoodC_419_zBRR_jLNF": "Sin pedido mínimo",
  "FoodC_419_gCIM_nQek": "Todos los métodos de pago",
  "FoodC_419_Bzsw_VoVQ": "Todas las ciudades",
  "FoodC_419_NGfm_Ulry": "Todas las tiendas",
  "coupon": {
    "other": {
      "time": "Válido hasta  {name} ",
      "hide": "Ocultar",
      "cost": "Aplica a {name}\n",
      "min": "Consumo mín. {{name}}",
      "show": "Más detalles",
      "cardBin": "Solo disponible si la bandeja de tarjetas es  {name} ",
      "limit": "Solo  {name} ",
      "new": "Solo para nuevos usuarios",
      "max": "Cubre hasta {{name}}",
      "off": " OFF",
      "limitUse": "Solo  {name} ",
      "use": "Aplicable en  {name} "
    },
    "costType": {
      "order": "Todo el pedido",
      "delivery": "Tarifa de entrega",
      "meals": "Plato participante"
    },
    "useRuleWeekDay": {
      "Monday": "Lunes",
      "Thursday": "Jueves",
      "Saturday": "Sábado",
      "Tuesday": "Martes",
      "Sunday": "Domingo",
      "Friday": "Viernes",
      "Wednesday": "Miércoles"
    },
    "payTypeList": {
      "all": "Todos los medios de pago",
      "card": "Tarjeta",
      "pay": "99Pay - Saldo",
      "pos": "Terminal Punto de Venta",
      "money": "Efectivo"
    }
  }
}